import { render, staticRenderFns } from "./RiskProfileQuestion.vue?vue&type=template&id=7216fc67&"
import script from "./RiskProfileQuestion.vue?vue&type=script&lang=ts&"
export * from "./RiskProfileQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./RiskProfileQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports